import React, { useState, useEffect, useRef } from 'react';
import { apis, apiHolder as api } from 'api';
import CloseSvg from '@web-common/components/UI/Icons/svgs/CloseSvg';
import CloseMailIcon from '@web-common/components/UI/Icons/svgs/CloseMailSvg';
import FoldIcon from '@web-common/components/UI/Icons/svgs/FoldIcon';
import ReplyIcon from '@web-common/components/UI/Icons/svgs/ReplySvg';
import ReplyAllIcon from '@web-common/components/UI/Icons/svgs/ReplyAllSvg';
import TransmitIcon from '@web-common/components/UI/Icons/svgs/TransmitSvg';
import WriteLetterIcon from '@web-common/components/UI/Icons/svgs/WriteLetterSvg';
import './Header.scss';
import NeedTempDialog from '../../../NeedTempDialog';
import { MailActions, useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { actions } from '@web-common/state/reducer/mailReducer';
import useReupload from '@web-mail-write/components/SendMail/useReupload';
import { getIn18Text } from 'api';
const WebHeader = () => {
    const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
    const { currentMail, mails } = useAppSelector(state => state.mailReducer);
    const currentMailId = currentMail.cid;
    const initSenderStr = currentMail.initSenderStr;
    const dispatch = useAppDispatch();
    const { doClearAllMails, doCloseMail, doChangeCurrentMail } = actions;
    const [needSaveMails, setNeedSaveMails] = useState([currentMail]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const curMails = useRef(mails);
    const [closeType, setCloseType] = useState('');
    const [closeMailcid, setCloseMailcid] = useState('');
    const { clearMidFile } = useReupload();
    const clickTab = (item) => {
        dispatch(doChangeCurrentMail(item.cid));
    };
    const iconMap = {
        reply: React.createElement(ReplyIcon, { className: "tab-icon" }),
        replyAll: React.createElement(ReplyAllIcon, { className: "tab-icon" }),
        forward: React.createElement(TransmitIcon, { className: "tab-icon" }),
        common: React.createElement(WriteLetterIcon, { className: "tab-icon" }),
    };
    useEffect(() => {
        window.onbeforeunload = () => {
            const needSave = curMails.current.filter(mail => mailApi.doNeedSaveTemp(mail));
            if (needSave.length > 0) {
                return getIn18Text('NINQUEDINGYAOLI');
            }
        };
        return () => {
            window.onbeforeunload = () => { };
        };
    }, []);
    useEffect(() => {
        curMails.current = mails;
    }, [mails]);
    const doCancelCompose = (cid) => {
        mailApi.doCancelCompose(cid, false, initSenderStr);
        clearMidFile(cid);
    };
    const closeMail = (type) => {
        if (type === 'hide') {
            dispatch(MailActions.doShowWebWrite(false));
            return;
        }
        if (type === 'close') {
            const needSave = mails.filter(mail => mailApi.doNeedSaveTemp(mail));
            if (needSave.length > 0) {
                setCloseType('');
                setNeedSaveMails(needSave);
                setIsModalVisible(true);
                return;
            }
            dispatch(doClearAllMails());
            mails.filter(mail => doCancelCompose(mail.cid));
        }
    };
    const onNotSave = () => {
        if (closeType === 'tab') {
            dispatch(doCloseMail(closeMailcid));
            doCancelCompose(closeMailcid);
            return;
        }
        dispatch(doClearAllMails());
        mails.filter(mail => doCancelCompose(mail.cid));
    };
    const comfirmSave = () => { };
    const closeTab = (item, e) => {
        e.stopPropagation();
        const needSave = mailApi.doNeedSaveTemp(currentMail);
        setCloseMailcid(item.cid);
        if (needSave) {
            setCloseType('tab');
            setNeedSaveMails([currentMail]);
            setIsModalVisible(true);
            return;
        }
        dispatch(doCloseMail(item.cid));
        doCancelCompose(item.cid);
    };
    const onSave = saveSuccess => {
        if (closeType === 'tab') {
            dispatch(doCloseMail(closeMailcid));
            if (!saveSuccess) {
                doCancelCompose(closeMailcid);
            }
            return;
        }
        if (!saveSuccess) {
            mails.filter(mail => doCancelCompose(mail.cid));
        }
        dispatch(doClearAllMails());
    };
    return (React.createElement("div", { className: "header handle" },
        React.createElement("div", { className: "tabs-box" }, mails.map(item => (React.createElement("div", { className: `tab ${item.cid === currentMailId ? 'active' : ''}`, key: item.cid, onClick: () => {
                clickTab(item);
            }, style: { width: `calc((100% - 120px)/${mails.length - 1})` } },
            React.createElement("div", { className: "tab-text" },
                React.createElement("span", { className: "tab-item" },
                    iconMap[item.entry.writeLetterProp],
                    item.entry.title || getIn18Text('WUZHUTI'))),
            item.cid === currentMailId && mails.length > 1 ? (React.createElement("div", { className: "tab-close-icon", onClick: e => {
                    closeTab(item, e);
                } },
                React.createElement(CloseSvg, null))) : (''))))),
        React.createElement("div", { className: "operate" },
            React.createElement("div", { className: "handle" }),
            React.createElement("div", { className: "operate-box" },
                React.createElement("div", { onClick: () => {
                        closeMail('hide');
                    } },
                    React.createElement(FoldIcon, null)),
                React.createElement("div", { onClick: () => {
                        closeMail('close');
                    } },
                    React.createElement(CloseMailIcon, null)))),
        React.createElement(NeedTempDialog, { isModalVisible: isModalVisible, onNotSave: () => {
                onNotSave();
            }, onSave: saveSuccess => {
                onSave(saveSuccess);
            }, needSaveMails: needSaveMails, setIsModalVisible: val => {
                setIsModalVisible(val);
            } })));
};
export default WebHeader;
